// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__C2Pcb","col":"styles_col__2ktWP"};